import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=57a83f24&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=js&"
export * from "./CategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelect.vue?vue&type=style&index=0&id=57a83f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a83f24",
  null
  
)

export default component.exports